import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useUpdateMember } from "@companion-core/shared/app/Queries";
import { PreferencesSwitchProps } from "../preferencesSwitch.model";
import {useNewsletterStore} from "@companion-core/shared/app/Store/newsletterStore";
import {useConfigStore} from "@companion-core/shared/app/Store/configStore";

export const usePreferencesSwitch = ({ entry, checked }: PreferencesSwitchProps) => {
  const { mutateAsync, isPending } = useUpdateMember();
  const { setDismissDate } = useNewsletterStore();
  const [isChecked, setChecked] = useState(checked ?? false);
  const { config } = useConfigStore((state) => ({ config: state.config }));
  const { t } = useTranslation();

  const updatePreferences = async (checked: boolean) => {
    try {
      await mutateAsync({
        id: "me",
        payload: { [`marketing_${entry.name}`]: checked ? "opt-in" : "opt-out" },
      });
      if (config?.modules?.newsletter?.enabled && entry.name === "email" && !checked) {
        setDismissDate(new Date().getTime());
      }
      setChecked(checked);
    } catch (e) {}
  };

  return {
    updatePreferences,
    isChecked,
    t,
    isPending,
  };
};
